module.exports = __webpack_public_path__ + "static/media/Ducha.7164e688.jpg";